import React from 'react';
import { connect, MapDispatchToProps } from 'react-redux';
import i18next from 'i18next';
import {
  watchTopic,
  unwatchTopic,
  suppressTopic,
} from '@wix/da-shared-react/pkg/redux/topic/actions';
import {
  addNotification,
  removeNotification,
} from '@wix/da-shared-react/pkg/Notifications/redux/actionCreators';
import { NotificationDuration } from '@wix/da-shared-react/pkg/Notifications/Notification';
import { NotificationType } from '@wix/da-shared-react/pkg/Notifications';
import CheckIcon from '@wix/da-ds/pkg/Icons/24x24/Check';
import { Props } from './TopicActions';

export type StateProps = Pick<Props, never>;
export type DispatchProps = Pick<
  Props,
  | 'watchTopic'
  | 'unwatchTopic'
  | 'suppressTopic'
  | 'addTopicNotification'
  | 'removeNotification'
>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  watchTopic,
  unwatchTopic,
  suppressTopic,
  addTopicNotification: (
    id: number,
    message: React.ReactNode,
    onUndo: () => void
  ) =>
    addNotification(NotificationType.Generic, {
      id,
      message,
      cardProps: {
        duration: NotificationDuration.S,
        limitTextWidth: false,
        iconComponent: CheckIcon,
        actions: [
          {
            type: 'positive',
            label: i18next.t('common.undo'),
            onClick: onUndo,
          },
        ],
      },
    }),
  removeNotification,
};

export default connect(null, mapDispatchToProps);
